module.exports = __webpack_public_path__ + "img/translate-01.6aa49f6f.svg";